<template>
  <Modal
    name="LINK_ASAAS_HOST_MODAL"
    :title="$t('host.label.linkAsaasAccount')"
    actions
  >
    <template v-slot:body>
      <v-form
        v-model="valid"
        class="mw-600 mx-auto"
        ref="linkAsaasHostForm"
      >
        <v-row>
          <v-col>
            <HTextInput
              v-model="asaasApiKey"
              :rules="[rules.required]"
              :label="$t('host.label.asaas.apiKey')"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeModal"
        :disabled="isLoading"
        elevation="0"
        class="mr-5"
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        :loading="isLoading"
        :disabled="!valid"
        color="primary"
        elevation="0"
        @click="linkAsaasHost"
      >
        {{ $t('host.label.asaas.link')}}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import HTextInput from '@/components/app/HTextInput'
import { required } from '@/util/errorHandling'
import router from '@/router'

export default {
  name: 'ModalLinkAsaasHost',

  components: {
    Modal,
    HTextInput
  },

  data() {
    return {
      rules: {
        required
      },
      asaasApiKey: null,
      valid: false,
    }
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['linkHostAsaasAccount']),
    ...mapMutations(['closeAllModals']),

    closeModal() {
      this.closeAllModals()
      this.asaasApiKey = null
    },

    linkAsaasHost() {
      const route = router?.history?.current
      const hostId = route?.query?.id
      this.linkHostAsaasAccount({
        user_id: hostId,
        api_key: this.asaasApiKey,
      })
    },
  },
}
</script>
